import { usePreflight } from '../api/queries';
import type { LiveKind } from './liveWords';

/**
 * СИМУЛЯТОР - НЕ ЭФИР. Единица 22, находка владельца по снимку эфира.
 *
 * Пока шёл симулятор, «Подключение» говорило «В эфире» зелёной точкой, а
 * строкой ниже - «Сначала выберите аккаунт TikTok». Сервер отвечал правду
 * (`connection.status === 'live'`, источник `synthetic`), а место показа
 * смотрело только на статус. Та же ошибка сидела в подсказках счётчиков
 * («за эфир») и в имени ленты для чтеца («Лента эфира»).
 *
 * Здесь - ОДНО определение, что сейчас идёт, и одни слова для каждого
 * случая. Места, где продукт называет состояние эфира, перечислены в `liveWords.ts`;
 * каждое ставит `data-live-place` и `data-live-state`. Ворота класса
 * `e2e/class-live.spec.ts` запускают симулятор и обходят список целиком;
 * `pnpm ui:check` (правило `UI-14`) сверяет список с разметкой.
 */
export { LIVE_PLACES, LIVE_WORDS } from './liveWords';
export type { LiveKind, LivePlace, LiveWords } from './liveWords';

/** Что идёт сейчас. Источник один - ответ готовности сервера. */
export function useLiveKind(): LiveKind {
  const preflight = usePreflight();
  const connection = preflight.data?.connection;

  if (connection?.status !== 'live') return 'none';

  return connection.sourceId === 'tiktok' ? 'tiktok' : 'simulator';
}
